import React, { createContext, useState } from "react";
export const FirebaseContext = createContext();

const FirebaseProvider = ({ children }) => {
  const [settings, setSetting] = useState(null);
  const [configData, setConfigData] = useState(null);
  const [apiTimestamps, setApiTimestamps] = useState(null);
  const [countryCallingCode, setCountryCallingCode] = useState(null);

  return (
    <FirebaseContext.Provider
      value={{
        settings,
        setSetting,
        configData,
        setConfigData,
        apiTimestamps,
        setApiTimestamps,
        countryCallingCode,
        setCountryCallingCode
      }}
    >
      {children}
    </FirebaseContext.Provider>
  );
};

export default FirebaseProvider;
